module.exports = __webpack_public_path__ + "static/media/development-lagos.52587147.png";